import { createActions, createReducer } from "../../helpers/Redux";
import initialState from "../models/qrCodes";

const { actions, types } = createActions({
  addQrCode: ["qrCode", "onSuccess", "onFailure"],
  updateQrCode: ["id", "qrCode", "onSuccess", "onFailure"],
  setLoading: ["loading"],
  fetchQrCodeRequest: ["page", "perPage", "onFailure"],
  exportQrCodeRequest: ["page", "perPage", "onSuccess", "onFailure"],
  setInitialFetchIsDone: [],
  setQrCodeTotalItems: ["totalItems"],
  setQrCodePerPage: ["perPage"],
  setQrCodePage: ["page"],
  addQrCodes: ["qrCodes"],
  setQrCodeQs: ["qs"],

  // fetchLocationRequest: ["onFailure"],
  // addLocations: ["locations"],

  // fetchTimezoneRequest: ["onFailure"],
  // addTimezone: ["timezones"],
});

const reducer = createReducer(initialState, {
  // [types.ADD_TIMEZONE]: (state, { payload }) => ({
  //   ...state,
  //   timezones: [...payload.timezones],
  // }),
  // [types.ADD_LOCATIONS]: (state, { payload }) => ({
  //   ...state,
  //   locations: [...payload.locations],
  // }),

  [types.ADD_QR_CODES]: (state, { payload }) => ({
    ...state,
    qrCodes: [...payload.qrCodes],
  }),
  [types.SET_LOADING]: (state, { payload }) => ({
    ...state,
    loading: payload.loading,
  }),
  [types.SET_INITIAL_FETCH_IS_DONE]: (state) => ({
    ...state,
    initialFetchIsDone: true,
  }),
  [types.SET_QR_CODE_TOTAL_ITEMS]: (state, { payload }) => ({
    ...state,
    totalItems: payload.totalItems,
  }),
  [types.SET_QR_CODE_PAGE]: (state, { payload }) => ({
    ...state,
    page: payload.page,
  }),
  [types.SET_QR_CODE_PER_PAGE]: (state, { payload }) => ({
    ...state,
    perPage: payload.perPage,
  }),
  [types.SET_QR_CODE_QS]: (state, { payload }) => ({
    ...state,
    qs: payload.qs,
    page: 0,
  }),
});

export { reducer as default, types, actions };
